<div class="jbm-table-header" [class]="className">
    <ng-content></ng-content>
</div>
